import { createContext } from "react";
import type { XAxisStore } from "../XAxisProvider.types";

const XAxisStoreContext = createContext<XAxisStore | undefined>(undefined);
XAxisStoreContext.displayName = "XAxisStoreContext";

export default XAxisStoreContext;
